import React from 'react';
import { TableRow, TableCell, Box } from '@mui/material';
import TaxbillStaticTableCell from './TaxbillStaticTableCell';

const TaxbillStaticsEmpRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        hq?.children &&
        hq?.children.map((dp, dpIndex) => {
          return dp?.children.map((emp, empIndex) => {
            return (
              <TableRow key={dp.id}>
                {dpIndex === 0 &&
                  dp.id !== 'total' &&
                  empIndex === 0 &&
                  emp.id !== 'total' && (
                    <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                      {hq.name}
                    </TableCell>
                  )}
                {empIndex === 0 && emp.id !== 'total' && (
                  <TableCell rowSpan={dp.rowSpan} sx={{ width: '110px' }}>
                    {dp.name}
                  </TableCell>
                )}
                <TableCell
                  sx={{ width: '100px' }}
                  align={emp.id === 'total' ? 'right' : 'left'}
                  colSpan={emp.id === 'total' ? 3 : 1}
                >
                  {emp.name}
                </TableCell>
                <TaxbillStaticTableCell data={emp} headerRows={headers} />
              </TableRow>
            );
          });
        })
      );
    })
  );
};

export default TaxbillStaticsEmpRow;
